import { motion } from 'framer-motion';

/**
 * Loading spinner component for lazy-loaded pages
 *
 * @remarks
 * Displays an animated spinner with the Cordalux brand styling
 * while components are being loaded asynchronously.
 *
 * @returns Animated loading spinner
 *
 * @public
 * @category Components
 */
export const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-900 to-black">
      <div className="text-center">
        {/* Spinning ring */}
        <motion.div
          className="w-16 h-16 border-4 border-yellow-400/30 border-t-yellow-400 rounded-full mx-auto mb-4"
          animate={{ rotate: 360 }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: "linear"
          }}
        />

        {/* Pulsing text */}
        <motion.p
          className="font-['Inter'] text-yellow-400 text-sm tracking-wider"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          Loading...
        </motion.p>
      </div>
    </div>
  );
};
